import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getEnquire, removeEnquire } from '../slice/enquireSlice';

const Enquire = () => {
  const dispatch = useDispatch();
  const enquireData = useSelector((state) => state.enquire);
  const userData = useSelector((state) => state.user);

  const headers = {
    Authorization: `Bearer ${userData?.token}`, // Include the token here
  };

  useEffect(() => {
    dispatch(getEnquire({ headers }));
  }, [dispatch, headers]);

  return (
    <div className="container-fluid px-lg-5">
      <div className="mainheadig">
        <h4 className="text-white font-weight-bold">Enquiry List</h4>
      </div>

      <table className="my-5 table table-striped table-responsive">
        <thead>
          <tr className="mt-5">
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col">City</th>
            <th scope="col">Experience</th>
            <th scope="col">Current Salary</th>
            <th scope="col">Resume</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {enquireData?.data?.length ? (
            <>
              {enquireData.data.map((item, i) => (
                <tr key={item.id}>
                  <td>{i + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.city}</td>
                  <td>{item.Experience}</td>
                  <td>{item.current_salary}</td>
                  <td>
                    {item.resume ? (
                      <a
                        href={item.resume}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Resume
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    <button
                      className="btn removebtn"
                      onClick={() => dispatch(removeEnquire(item.id))}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td className="text-center" colSpan={9}>
                <span>No Data Found</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Enquire;
